import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const SignupCardCta = ({ copy, formId, isDisabled, isSubmitting }) => (
  <button
    className={classNames({
      'bt bt--primary bt--lg bt--width-full': true,
      'bt--waiting': isSubmitting,
    })}
    type="submit"
    disabled={isSubmitting || isDisabled}
    form={formId}>
    {copy || <FormattedMessage id="signup-card.general.action" defaultMessage="Continue" />}
  </button>
);

SignupCardCta.propTypes = {
  copy: PropTypes.node,
  formId: PropTypes.string,
  isDisabled: PropTypes.bool,
  isSubmitting: PropTypes.bool,
};
